import { render, staticRenderFns } from "./ProvinceWorkerCase.vue?vue&type=template&id=368b2ee2&scoped=true"
import script from "./ProvinceWorkerCase.vue?vue&type=script&lang=js"
export * from "./ProvinceWorkerCase.vue?vue&type=script&lang=js"
import style0 from "./ProvinceWorkerCase.vue?vue&type=style&index=0&id=368b2ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b2ee2",
  null
  
)

export default component.exports